/**
 * Resolve branch name/code for print & PDF exports.
 * Priority: explicit options → admin view filter → logged-in user branch.
 */
export const resolveBranchForPrint = (options = {}) => {
  if (options.branchName || options.branch_name || options.branch?.name) {
    const name = options.branchName || options.branch_name || options.branch?.name || '';
    const code =
      options.branchCode ||
      options.branch_code ||
      options.branch?.branch_code ||
      '';
    return { name, code, label: formatBranchLabel(name, code) };
  }

  const filterId = localStorage.getItem('erp_admin_branch_filter');
  if (filterId) {
    try {
      const cached = localStorage.getItem('erp_branches_cache');
      if (cached) {
        const list = JSON.parse(cached);
        const found = (list || []).find((b) => String(b.id) === String(filterId));
        if (found) {
          return {
            name: found.name || '',
            code: found.branch_code || '',
            label: formatBranchLabel(found.name, found.branch_code)
          };
        }
      }
    } catch (_) {
      /* ignore */
    }
    return { name: `Branch #${filterId}`, code: '', label: `Branch #${filterId}` };
  }

  const name = localStorage.getItem('erp_branch_name') || '';
  const code = localStorage.getItem('erp_branch_code') || '';
  try {
    const raw = localStorage.getItem('erp_user');
    if (raw) {
      const u = JSON.parse(raw);
      const n = u.branch_name || name;
      const c = u.branch_code || code;
      if (n || c) return { name: n, code: c, label: formatBranchLabel(n, c) };
    }
  } catch (_) {
    /* ignore */
  }

  if (name || code) return { name, code, label: formatBranchLabel(name, code) };
  return { name: 'All Branches', code: '', label: 'All Branches' };
};

export const formatBranchLabel = (name, code) => {
  const n = String(name || '').trim();
  const c = String(code || '').trim();
  if (n && c) return `${n} (${c})`;
  return n || c || 'All Branches';
};

/** Cache branches for PDF helpers (called from BranchContext) */
export const cacheBranchesForPrint = (branches = []) => {
  try {
    localStorage.setItem('erp_branches_cache', JSON.stringify(branches || []));
  } catch (_) {
    /* ignore */
  }
};
